import * as React from 'react';
import { RouteComponentProps } from 'react-router';

import SearchBar from '../SearchBar';
import { IResetSearchBar } from '../SearchBar/SearchBar';
import AccountMenu from 'src/components//AccountMenu';
import RegionSwitch from 'src/components/RegionSwitch';
import MyOrdersMenu from 'src/components/MyOrdersMenu';
import MyFavoritesMenu from 'src/components/MyFavoritesMenu';
import GoToCart from 'src/components/GoToCart';
import MyOrdersTracking from 'src/components/MyOrdersTracking';
import MSRPToggle from '../MSRPToggle';
import LocationsButton from '../LocationsButton';
import './Menu.scss';
import { isMobile, isMobilelandscape } from 'src/utils/responsiveHelpers';
import MobileMenu from '../MobileMenu';
import MoreMenuItem from '../MoreMenuItem';
import logo from 'src/assets/images/rp_logo.png';
import rpLogo from 'src/assets/rpLogo';
import frrpLogo from 'src/assets/frrpLogo';
import miles from 'src/assets/miles';
import milesFr from 'src/assets/milesBannerFr';
import i18n from 'src/translation/i18n';
import {
  ifLoggedIn,
  goToPartDetail,
  goToModelDetail,
  getSiteLanguage
} from 'src/utils/navigation';
import Notifications from '../Notifications';
import { env } from 'src/shared/env';

interface IMenuProps extends RouteComponentProps {
  handleOnSubmitSearch(searchText: string): void;
  handleOnSearchSelectedPart(searchText: string): void;
  handleOnSearchSelectedModel(name: string, manufacturer: string): void;
  shouldShowSearchDropdown?: boolean;
  isMobile: boolean;
  scrolled: boolean;
  isLoggedIn: boolean;
  content: any;
}

export default class Menu extends React.Component<IMenuProps, any> {
  constructor(props: any) {
    super(props);

    this.state = {
      isMobile: isMobile(),
      actualUrl: '',
      resetSearchbar: { update: false, value: false },
      scrolled: false,
      showSarchbar: false
    };
  }

  public componentWillMount() {
    window.addEventListener('resize', this.handleWindowSizeChange);
    window.addEventListener('scroll', this.handlescroll);
  }

  public componentWillUnmount() {
    window.removeEventListener('resize', this.handleWindowSizeChange);
    window.removeEventListener('scroll', this.handlescroll);
  }

  public handlescroll = () => {
    const isTop = window.scrollY < 50;
    const div = document.querySelector('.nav');
    if (div && div.classList) {
      if (isTop !== true && window.location.hash !== '') {
        this.setState({ scrolled: true });
        div.classList.add('special-nav');
      } else {
        this.setState({ scrolled: false });
        div.classList.remove('special-nav');
      }
    }
  };

  public handleWindowSizeChange = () => {
    const isMob = isMobile();
    if (isMob !== this.state.isMobile) {
      this.setState({ isMobile: isMob });
    }
  };

  public componentDidMount() {
    const update = !this.state.resetSearchbar.update;
    this.setState({
      actualUrl: this.props.location,
      resetSearchbar: { update, value: true }
    });
  }

  public componentDidUpdate(prevProps: any, prevState: any) {
    if (prevState.actualUrl !== this.props.location) {
      const update = !this.state.resetSearchbar.update;
      this.setState({
        resetSearchbar: { update, value: true },
        actualUrl: this.props.location,
        showSarchbar: this.props.content ? true : false
      });
    }
  }

  public setResetSearchbar = (value: IResetSearchBar) => {
    this.setState({ resetSearchbar: value });
  };

  private renderDesktop() {
    const language = window.localStorage.getItem('i18nextLng');
    let lng = 'en';
    if (language) {
      lng = language.split('-')[0];
    }
    return (
      <div className={this.state.scrolled ? 'nav scrolled' : 'nav'}>
        <div className="row no-gutters">
          <div
            className={
              lng === 'fr' ? 'rp-logo-div rp-logo-div-fr' : 'rp-logo-div'
            }
          >
            <div className="rp-logo-section">
              <MobileMenu />
              <div className="rpdevdummy-title ">
                <a
                  // href="/us/"
                  href={
                    env.REACT_APP_BASE_ENVIRONMENT === 'CA'
                      ? `/ca/${getSiteLanguage()}/`
                      : '/us/'
                  }
                  className="rp-logo"
                >
                  {getSiteLanguage() === 'fr' ? <img src={frrpLogo} alt="Reliable Parts Logo" /> :<img src={rpLogo} alt="Reliable Parts Logo" />} 
                  
                  {/* <h1 className={i18n.language === 'fr' ? '' : ''}>
                    {i18n.t('common.housofMillionParts')}
                  </h1> */}
                </a>
              </div>
              <div>
                <div
                  className={
                    window.location.hash !== ''
                      ? 'nav-searchbar showSearchBar'
                      : 'nav-searchbar'
                  }
                >
                  <SearchBar
                    resetSearchbar={this.state.resetSearchbar}
                    setResetSearchbar={this.setResetSearchbar}
                    location={this.props.history.location}
                    handleOnSubmitSearch={this.props.handleOnSubmitSearch}
                    handleOnSelectedPart={this.onSearchSelectedPart}
                    handleOnSelectedModel={this.onSearchSelectedModel}
                    shouldShowItems={this.props.shouldShowSearchDropdown}
                    placeholder={i18n.t('common.bannerSearchPlaceHolder')}
                    aria-label={"Search millions of parts and models"}
                  />
                </div>
              </div>

              {env.REACT_APP_BASE_ENVIRONMENT === 'CA' ? (
                isMobilelandscape() === true &&
                (this.state.showSarchbar === true ||
                  this.state.scrolled === true) ? (
                  ''
                ) : (
                  <div className="banner-miles">
                    <a
                      // href="/us/"
                      href={
                        env.REACT_APP_BASE_ENVIRONMENT === 'CA'
                          ? `https://www.reliableparts.ca/airmiles/`
                          : 'https://www.reliableparts.ca/airmiles/'
                      }
                      // className="rp-logo rp-temp-logo"
                      target="_blank"
                    >
                      <img
                        src={i18n.language === 'en-CA' ? miles : milesFr}
                        alt="airmiles"
                      />
                    </a>
                  </div>
                )
              ) : (
                ''
              )}
            </div>
          </div>
          <div className="rp-menu-section">
            <div id="rp-menu" className="no-select">
              <div
                className={
                  this.state.scrolled || this.state.showSarchbar
                    ? 'rp-menu--menu-item rp-region-switcher-menu hideMenu'
                    : 'rp-menu--menu-item rp-region-switcher-menu smallTabView'
                }
              >
                <RegionSwitch />
              </div>
              <span
                className={
                  this.state.scrolled || this.state.showSarchbar
                    ? 'menu-divider hideMenuDivider'
                    : 'menu-divider smallTabView largeTabview'
                }
              />
              <div
                // className="rp-menu--menu-item"
                className={
                  this.props.isLoggedIn
                    ? 'rp-menu--menu-item rp-show-toggle'
                    : 'rp-menu--menu-item rp-hide-toggle'
                }
              >
                <MSRPToggle />
              </div>
              <span
                // className="menu-divider"
                className={
                  this.props.isLoggedIn
                    ? 'menu-divider'
                    : 'menu-divider hideMenuDivider'
                }
              />
              <div
                className={
                  this.state.scrolled || this.state.showSarchbar
                    ? 'rp-menu--menu-item hideMenu'
                    : 'rp-menu--menu-item tabView smallTabView'
                }
              >
                <LocationsButton />
              </div>
              <span
                className={
                  this.state.scrolled || this.state.showSarchbar
                    ? 'menu-divider hideMenuDivider tabView'
                    : 'menu-divider tabView smallTabView'
                }
              />
              <div className="rp-menu--menu-item rp-menu-tracking-item tabView largetabview">
                <MyOrdersTracking />
              </div>
              <span className="menu-divider tabView largetabview" />
              <div className="rp-menu--menu-item tabView smallTabView">
                <Notifications />
              </div>
              <span className="menu-divider tabView smallTabView" />
              <div className="rp-menu--menu-item">
                <MyOrdersMenu />
              </div>
              <span className="menu-divider" />
              <div
                className={
                  this.state.scrolled || this.state.showSarchbar
                    ? 'rp-menu--menu-item-more showMenu'
                    : 'rp-menu--menu-item-more'
                }
              >
                <MoreMenuItem />
              </div>
              <span
                className={
                  this.state.scrolled || this.state.showSarchbar
                    ? 'menu-divider largetabview'
                    : 'menu-divider hideMenuDivider largetabview'
                }
              />
              <div className="rp-menu--menu-item smallTabView">
                <GoToCart />
              </div>
              <span className="menu-divider smallTabView" />
              <div className="rp-menu--menu-item">
                <AccountMenu
                  scrolled={this.state.scrolled || this.state.showSarchbar}
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }

  private renderMobile() {
    return (
      <div id="rp-menu" className="rp-menu-mobile-view no-select">
        <div className="rp-logo-section">
          <MobileMenu />
          <div className="rpdevdummy-title">
            <a
              href={
                env.REACT_APP_BASE_ENVIRONMENT === 'CA'
                  ? `/ca/${getSiteLanguage()}/`
                  : '/us/'
              }
              className="rp-logo"
            >
              <img src={rpLogo} alt="Reliable Parts logo" />
              {/* <h1>{i18n.t('common.housofMillionParts')}</h1> */}
            </a>
          </div>
        </div>
        <div className="rp-menu-list-align">
          {env.REACT_APP_BASE_ENVIRONMENT === 'CA' ? (
            <div className="banner-milesmobile">
              <a
                // href="/us/"
                href={
                  env.REACT_APP_BASE_ENVIRONMENT === 'CA'
                    ? `https://www.reliableparts.ca/airmiles/`
                    : 'https://www.reliableparts.ca/airmiles/'
                }
                // className="rp-logo rp-temp-logo"
                target="_blank"
              >
                <img
                  src={i18n.language === 'en-CA' ? miles : milesFr}
                  alt="airmiles"
                />
              </a>
            </div>
          ) : (
            ''
          )}
          <div className="rp-menu--menu-item">
            <AccountMenu isMobile={true} />
          </div>
          <div className="rp-menu--menu-item">
            <GoToCart isMobile={true} />
          </div>
        </div>
      </div>
    );
  }

  public render() {
    return this.state.isMobile ? this.renderMobile() : this.renderDesktop();
  }

  private onSearchSelectedPart = (text: string) => {
    ifLoggedIn(() => goToPartDetail(text));
  };

  private onSearchSelectedModel = (name: string, manufacturer: string) => {
    ifLoggedIn(() => goToModelDetail(name, manufacturer));
  };
}
